module.exports = __webpack_public_path__ + "static/media/left.d2366aa3.webp";